
export const GET_AI_SETTINGS_STARTED = "GET_AI_SETTINGS_STARTED"
export const GET_AI_SETTINGS_SUCCESS = "GET_AI_SETTINGS_SUCCESS"
export const GET_AI_SETTINGS_FAILURE = "GET_AI_SETTINGS_FAILURE"

export const UPDATE_AI_GENERAL_SETTINGS_STARTED = "UPDATE_AI_GENERAL_SETTINGS_STARTED"
export const UPDATE_AI_GENERAL_SETTINGS_SUCCESS = "UPDATE_AI_GENERAL_SETTINGS_SUCCESS"
export const UPDATE_AI_GENERAL_SETTINGS_FAILURE = "UPDATE_AI_GENERAL_SETTINGS_FAILURE"

export const UPDATE_AI_RULE_SETTINGS_STARTED = "UPDATE_AI_RULE_SETTINGS_STARTED"
export const UPDATE_AI_RULE_SETTINGS_SUCCESS = "UPDATE_AI_RULE_SETTINGS_SUCCESS"
export const UPDATE_AI_RULE_SETTINGS_FAILURE = "UPDATE_AI_RULE_SETTINGS_FAILURE"

export const UPDATE_AI_HOURS_STARTED = "UPDATE_AI_HOURS_STARTED"
export const UPDATE_AI_HOURS_SUCCESS = "UPDATE_AI_HOURS_SUCCESS"
export const UPDATE_AI_HOURS_FAILURE = "UPDATE_AI_HOURS_FAILURE"

export const CANCEL_AI_RECEPTIONIST_STARTED = "CANCEL_AI_RECEPTIONIST_STARTED"
export const CANCEL_AI_RECEPTIONIST_SUCCESS = "CANCEL_AI_RECEPTIONIST_SUCCESS"
export const CANCEL_AI_RECEPTIONIST_FAILURE = "CANCEL_AI_RECEPTIONIST_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"
